// jiboomba URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/jiboomba";

// const BASE_URL = "https://iccpanel.com/api/v1/Betwise";
// const BASE_URL = "https://iccpanel.com/api/v1/betwise";
//
const BASE_URL = "https://iccpanel.com/api/v1/betwise";

// Namibia URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/test2";
// const BASE_URL = "https://staging.syscorp.in/api/v1/Betwise";
// const BASE_URL = "https://iccpanel.com/api/v1/betwise";

export default BASE_URL;
